/**
 * "Elsewhere": the open records the columns do not hold, counted by why, each
 * a way to where it is worked. Never a column -- the board does not invent a
 * place for work that has its own. A bucket with nothing in it is not drawn.
 */
import React, { useRef } from 'react';
import useScrollFade from './useScrollFade';
import type { ElsewhereBucket } from './types';

const nf = new Intl.NumberFormat('en-US');

export default function ElsewhereStrip({ label, buckets, note }: { label: string; buckets: ElsewhereBucket[]; note?: React.ReactNode }) {
  const shown = buckets.filter((b) => b.count > 0);
  const list = useRef<HTMLUListElement>(null);
  useScrollFade(list, [shown.length]);
  if (!shown.length) return null;
  const total = shown.reduce((s, b) => s + b.count, 0);
  return (
    <nav className="okb-elsewhere" aria-label={label}>
      <span className="okb-elsewhere__label">{label}<span className="okb-elsewhere__total">{nf.format(total)}</span></span>
      <ul ref={list}>
        {shown.map((b) => {
          const body = (
            <>
              <span className="okb-elsewhere__name">{b.label}</span>
              <span className="okb-elsewhere__n">{nf.format(b.count)}</span>
            </>
          );
          return (
            <li key={b.key} data-bucket={b.key}>
              {b.href ? (
                <a href={b.href} title={b.what} onClick={b.onSelect ? (e) => { e.preventDefault(); b.onSelect!(); } : undefined}>{body}</a>
              ) : b.onSelect ? (
                <button type="button" title={b.what} onClick={b.onSelect}>{body}</button>
              ) : (
                <span title={b.what}>{body}</span>
              )}
            </li>
          );
        })}
      </ul>
      {note && <span className="okb-elsewhere__note">{note}</span>}
    </nav>
  );
}
